module.exports = __webpack_public_path__ + "static/media/teeth-color.8eb8686d.svg";